// Utility functions for string manipulation
export function capitalizeFirstLetter(
  string: string | undefined | null
): string {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
}

// Helper function to truncate text to a specified length
export function truncateText(text: string, maxLength: number): string {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + '...';
  }
  return text;
}
